import { UploaderType } from "../domain/uploaderType";
import storage from "../services/storageAdapter";
import { StorageService } from "./ports";

type Deps = {
	storage: StorageService;
};

const defaultDeps = {
	storage,
};

function switchToExternalType(deps: Deps = defaultDeps): UploaderType {
	const { storage } = deps;

	storage.setUploaderType(UploaderType.External);

	return storage.getUploaderType();
}

export default switchToExternalType;
